import { render, staticRenderFns } from "./AttendWorkerAddOrUpdate.vue?vue&type=template&id=024bbfa8&scoped=true&"
import script from "./AttendWorkerAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./AttendWorkerAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024bbfa8",
  null
  
)

export default component.exports